export const isFirefox = () => {
  const userAgent = navigator?.userAgent.toLowerCase()
  return userAgent.includes('firefox') && !userAgent.includes('chrome')
}
